import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';

// actions
import { currentManagerValidate } from '../../../actions/currentManagerActions';
import { getFormValues } from 'redux-form/immutable';

// components
import { Button, Error, PhoneNumberInput, StateSelect } from '../../shared/_form';
import { Field } from 'redux-form/immutable';

// images
import bookImage from '../../../assets/images/book';

class PersonalInformation extends React.Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Immutable.Map),
    formValues:  PropTypes.instanceOf(Immutable.Map)
  }

  render() {
    const loading = this.props.currentUser.get('loading');
    const errors  = this.props.currentUser.get('error') || Immutable.Map();

    return (
      <div className='manager-new__step1'>
        <img className='manager-new__step1__book' src={ bookImage } />
        <p className='manager-new__step1__description'>
          We need to know a little more about you first, but then let us help you
          get rid of messy books!
        </p>
        <form className='manager-new__step1__form'
          onSubmit={ this._handleSubmit }>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component='input'
              name='office.name'
              placeholder='Office Name'
              type='text' />
            <Error className='form__error--rounded'>{ errors.get('office.name') }</Error>
          </div>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component='input'
              name='name'
              placeholder='Your Name'
              type='text' />
            <Error className='form__error--rounded'>{ errors.get('name') }</Error>
          </div>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component='input'
              name='email'
              placeholder='Email'
              type='email' />
            <Error className='form__error--rounded'>{ errors.get('user.email') }</Error>
          </div>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component='input'
              name='password'
              placeholder='Password'
              type='password' />
            <Error className='form__error--rounded'>{ errors.get('user.password') }</Error>
          </div>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component='input'
              name='office.address'
              placeholder='Address'
              type='text' />
            <Error className='form__error--rounded'>{ errors.get('office.address') }</Error>
          </div>
          <div className='form__group'>
            <div className='manager__form__office__city'>
              <Field className='form__field form__field--rounded'
                component='input'
                name='office.city'
                placeholder='City'
                type='text' />
              <Error className='form__error--rounded'>{ errors.get('office.city') }</Error>
            </div>
            <div className='manager__form__office__state'>
              <Field className='form__select'
                component={ this._renderStateSelect }
                name='office.state'
                placeholder='State' />
              <Error className='form__error'>{ errors.get('office.state') }</Error>
            </div>
            <div className='manager__form__office__postal-code'>
              <Field className='form__field form__field--rounded'
                component='input'
                name='office.postalCode'
                placeholder='Zip Code'
                type='text' />
              <Error className='form__error--rounded'>{ errors.get('office.postalCode') }</Error>
            </div>
          </div>
          <div className='form__group'>
            <Field className='form__field form__field--rounded'
              component={ this._renderPhoneNumberInput }
              name='office.phoneNumber'
              placeholder='Phone Number' />
            <Error className='form__error--rounded'>{ errors.get('office.phoneNumber') }</Error>
          </div>
          <div className='form__submit'>
            <Button className='form__button form__button--green manager-new__form__button'
              loading={ loading }>
              Next
            </Button>
          </div>
        </form>
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const form = this.props.formValues || Immutable.Map();
    const { dispatch } = this.props;

    dispatch(currentManagerValidate(form.toJS()));
  }

  _renderPhoneNumberInput({ input, meta, ...rest }) {
    return <PhoneNumberInput { ...input } { ...rest } />;
  }

  _renderStateSelect({ input, meta, ...rest }) {
    const value = input.value && input.value.length > 0 ? input.value : 'placeholder';

    return <StateSelect { ...input } { ...rest } value={ value } />;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues('managerNew')(state)
  };
};

export default (
  connect(mapStateToProps)(
    reduxForm(
      {
        destroyOnUnmount: false,
        form: 'managerNew'
      }
    )(PersonalInformation)
  )
);



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_PersonalInformation.jsx